import React from 'react';
import { styled } from '@linaria/react';
import { NoStyleLink } from '@daedalus/atlas/helpers/NoStyleLink';
import useIsImageloaded from '@daedalus/atlas/hooks/useIsImageloaded';
interface Props {
  /** The language in which the store logos should render */
  lang?: string;
  /** The URL pointing to the Apple App Store page */
  appleAppStoreUrl?: string;
  /** The URL pointing to the Google Play page */
  googlePlayUrl?: string;
}
interface BadgeProps {
  lang?: string;
  height?: number;
}
const ButtonsWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonsWrapper",
  class: "b1od5dwn",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => NoStyleLink;
const FlexNoStyleLink = /*#__PURE__*/styled(_exp2())({
  name: "FlexNoStyleLink",
  class: "fszh9bh",
  propsAsIs: true
});
const appleAppStoreLangMap = {
  'zh-HK': 'zh',
  'zh-TW': 'zh'
} as {
  [key: string]: string;
};
export const AppleAppStoreBadge = ({
  lang = 'en',
  height = 40
}: BadgeProps) => {
  const supportedLang = appleAppStoreLangMap[lang] || lang;
  const imageSrc = `https://i.fih.io/appStoreBadges/appleAppStore/${supportedLang}.svg`;
  const fallbackSrc = 'https://i.fih.io/appStoreBadges/appleAppStore/en.svg';
  const {
    isErrored
  } = useIsImageloaded(imageSrc);
  return <img src={isErrored && fallbackSrc ? fallbackSrc : imageSrc} alt={'Apple App Store badge'} height={height} />;
};
export const GooglePlayBadge = ({
  lang = 'en',
  height = 40
}: BadgeProps) => {
  const imageSrc = `https://i.fih.io/appStoreBadges/googlePlay/${lang}.svg`;
  const fallbackSrc = 'https://i.fih.io/appStoreBadges/googlePlay/en.svg';
  const {
    isErrored
  } = useIsImageloaded(imageSrc);
  return <img src={isErrored && fallbackSrc ? fallbackSrc : imageSrc} alt={'Google Play badge'} height={height} />;
};
export const AppButtonsWidget = ({
  lang,
  appleAppStoreUrl,
  googlePlayUrl
}: Props) => <ButtonsWrapper>
    <FlexNoStyleLink href={appleAppStoreUrl}>
      <AppleAppStoreBadge lang={lang} />
    </FlexNoStyleLink>
    <FlexNoStyleLink href={googlePlayUrl}>
      <GooglePlayBadge lang={lang} />
    </FlexNoStyleLink>
  </ButtonsWrapper>;

require("./AppButtonsWidget.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AppButtonsWidget.tsx");